import authenticatedServiceInstance from '../../../services/AuthenticatedService';
const fetchOpdData = async (date_type, date_from, date_to, mobile_no, doctor_id) => {

	const BASE_URL = process.env.REACT_APP_BASE_URL;
	const token = authenticatedServiceInstance.getToken(); // Replace with your actual Bearer token

  try {
    const response = await fetch(`${BASE_URL}/opdManager/getOpdData?date_type=${date_type}&date_from=${date_from}&date_to=${date_to}&mobile_no=${mobile_no}&doctor_id=${doctor_id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    if (!response.ok) {
      throw new Error('Failed to fetch states');
    }
    return await response.json();
   
  } catch (error) {
    console.error(error);
		throw new Error(error.message);
  }
};

export {fetchOpdData};